import { useEffect } from "react";
import { useInView } from "react-intersection-observer";

/**
 * This hook will take a function, and returns a ref.
 * ref can be assigned to any JSX element as prop, and
 * when at least 50% of the element is within the center of the viewport, the passed
 * in function will be called with the element id as parameter.
 * @param {function} action 
 * @returns {function} ref
 */
export default function useScrollObserver(action) {
    const {ref, inView, entry} = useInView({
        rootMargin: '-50% 0% -50% 0%',
        threshold: 0.5
    })
    useEffect(() => {
        if (entry && inView) {
            action(entry.target.id);
        }
    }, [entry, action, inView])
    return ref
}
